import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 120;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: 60, fixed: "left" },
  { prop: 'code', label: '实物条码', width: 160 , fixed: "left"},
  { prop: 'CarSignNum', label: '车签号', width: 140 },
  { prop: 'NextOrgName', label: '下一网点', width: 160 },
  { prop: 'strDestOrgName', label: '目的地', width: 160 },
  { prop: 'state', label: '状态', width: 90 },
  { prop: 'PutinWeight', label: '输入重', width: 70 },
  // { prop: 'volumnWeight', label: '体积重', width: defaultWidth },
  { prop: 'weight', label: '称入重', width: 70 },
  { prop: 'length', label: '长', width: 55 },
  { prop: 'width', label: '宽', width: 55 },
  { prop: 'height', label: '高', width: 55 },
  { prop: 'strEmployeeName', label: '收派员', width: 100 },
  { prop: 'strCustomerName', label: '寄件客户', width: 100},
  { prop: 'scanTime', label: '扫描时间', width: 140 },
  { prop: 'LineName', label: '线路', width: null },
  { prop: 'message', label: '提示/警告信息', width: 140 , fixed: "right"},

];
export default { tableHeader }
